import { render, staticRenderFns } from "./LoginRegister.vue?vue&type=template&id=03525a45"
import script from "./LoginRegister.vue?vue&type=script&lang=js"
export * from "./LoginRegister.vue?vue&type=script&lang=js"
import style0 from "./LoginRegister.vue?vue&type=style&index=0&id=03525a45&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports